/**
 * Pure presentational config + helpers for the seller-select + PIN screen. No
 * React, no state — role visuals, the PIN-pad layout and initials.
 */
import type { AuthRole } from '@/api/models';
import { getNameInitials, type SignOutReason } from '@/utils';

// The PIN-pad layout/length now live in the shared pad component; re-exported
// here so this module's public API (and the login tests) stay stable.
export {
    PIN_LENGTH,
    PIN_PAD_KEYS,
    type PinPadAction,
} from '@/components/pinPad/pinPadMeta';

/** Per-role card visuals, reusing the POS chip/icon vocabulary. */
export type RoleMeta = {
    icon: string;
    /** HeroUI `Chip` / accent colour token. */
    color: 'accent' | 'warning';
};

export const ROLE_META: Record<AuthRole, RoleMeta> = {
    BranchAdmin: {
        icon: 'solar:shield-user-bold-duotone',
        color: 'warning',
    },
    Seller: {
        icon: 'solar:user-rounded-bold-duotone',
        color: 'accent',
    },
};

/** i18n key for a role's label. */
export const getRoleLabelKey = (role: AuthRole): string =>
    role === 'BranchAdmin'
        ? 'sellerLogin.roleBranchAdmin'
        : 'sellerLogin.roleSeller';

/** `pages` key explaining each recorded sign-out reason (SEL-23). */
export const SIGN_OUT_NOTICE_KEYS: Record<SignOutReason, string> = {
    sessionRevoked: 'sellerLogin.sessionRevoked',
};

/** Up-to-two-letter initials for an avatar fallback. */
export const getInitials = getNameInitials;
